import React, { useMemo, useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { createRouter } from './router'
import { AuthProvider } from './lib/auth.context'
import { Toaster } from 'sonner'
import { ThemeProvider } from './lib/theme-context'
import { handlePreRouterErrors } from './lib/pre-router-error-handler'
import { getAuthTimeoutConfig } from './lib/env'

export default function App() {
  const queryClient = useMemo(() => new QueryClient({}), [])

  // Get timeout configuration from environment variables
  const authTimeoutConfig = useMemo(() => getAuthTimeoutConfig(), [])

  // Handle error parameters before router initialization
  useEffect(() => {
    handlePreRouterErrors()
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <HelmetProvider>
          <AuthProvider
            inactivityTimeoutMs={authTimeoutConfig.inactivityTimeoutMs}
            warningTimeMs={authTimeoutConfig.warningTimeMs}
          >
            <RouterProvider router={createRouter()} />
            <Toaster />
          </AuthProvider>
        </HelmetProvider>
        <ReactQueryDevtools />
      </ThemeProvider>
    </QueryClientProvider>
  )
}
